import { useActiveFilters } from '..'

/**
 * Returns a subset group of flags based on which `neq` filters are currently active.
 */
export const useActiveFilterFlags = flags => {
  const filters = useActiveFilters()
  const neqFilters = filters
    .filter(f => f[0] === 'neq')
    .map(f => f[1])
  const activeFlags = flags.filter(f => !neqFilters.includes(f))
  if (!activeFlags || activeFlags.length === flags.length)
    return []
  return activeFlags
}
